export { fetchOrganisationListPage } from '../../intervene/adapters/organisationListAdapter';

export function extractOrganisationList(data) {
  if (Array.isArray(data)) return data;
  return data?.list ?? data?.results ?? [];
}
